import { Label } from 'recharts';
import { i18next } from '@frontend/i18n';
import { theme } from '@frontend/theme';

// Due to limitation within recharts, we cannot define or use it as a component.
// Instead, we have to use it as a function.
export const renderCustomCenterLabel = (value: string) => {
  return (
    <>
      <Label
        dy={45}
        fill={theme.colors.white}
        fontSize={12}
        position='top'
        value={i18next.t('From', { ns: 'analytics' })}
      />
      <Label dy={62} fill={theme.colors.white} fontSize={12} position='top' value={value} />
    </>
  );
};
